import { TAX_CATEGORIES } from "./services-a";
import { ADVISORY_CATEGORIES } from "./services-b";

export const CATEGORIES = [...TAX_CATEGORIES, ...ADVISORY_CATEGORIES];

export const SERVICES = CATEGORIES.flatMap((c) =>
  c.services.map((s) => ({ ...s, category: c.title, categorySlug: c.slug, categoryProcess: c.process }))
);

export const SERVICE_MAP = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

export const SERVICE_OPTIONS = [
  ...SERVICES.map((s) => s.title),
  "Other / General Enquiry",
];

export const getRelatedServices = (service) =>
  SERVICES.filter((s) => s.categorySlug === service.categorySlug && s.slug !== service.slug).slice(0, 4);
